export interface CryptCertInfo {
    lastName: string;
    firstName: string;
    middleName: string;
    inn: string;
    email: string;
    post: string;
}
